import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
var AppComponent = /** @class */ (function () {
    function AppComponent(translateService, route) {
        this.translateService = translateService;
        this.route = route;
        // this language will be used as a fallback when a translation isn't found in the current language
        this.translateService.setDefaultLang('de');
        // the lang to use, if the lang isn't available, it will use the current loader to get them
        this.translateService.use('de');
    }
    AppComponent.prototype.ngOnInit = function () {
        var _this = this;
        // callback for query parameter
        this.route.queryParams.subscribe(function (params) {
            if (params.lang) {
                _this.translateService.use(params.lang);
            }
        });
    };
    return AppComponent;
}());
export { AppComponent };
